import React from "react";
import { Iconography, IconographySizes } from "@hid-galaxy-ui/galaxy-react";
import { PendingActionData, PendingActionIcon } from "../../types";

interface PendingActionsCardProps {
  actions: PendingActionData[];
  openCount: number;
  isStaticDisabled?: boolean;
}

const ACTION_ICONS: Record<PendingActionIcon, string> = {
  warning: "triangleExclamation",
  document: "file",
  check: "circleCheck",
};

const PendingActionsCard: React.FC<PendingActionsCardProps> = ({
  actions,
  openCount,
  isStaticDisabled = false,
}) => {
  return (
    <div
      className={`pending-actions-card${
        isStaticDisabled ? " pending-actions-card--static-disabled" : ""
      }`}
    >
      <div className="pending-actions-card__header">
        <span className="pending-actions-card__alerts-pill">Alerts</span>
        <div className="pending-actions-card__title-row">
          <h3 className="pending-actions-card__title">Pending Actions</h3>
          <span className="pending-actions-card__open-pill">{openCount} Open</span>
        </div>
      </div>

      <ul className="pending-actions-card__list">
        {actions.length > 0 ? (
          actions.map((action, index) => (
            <li
              key={action.id}
              className={`pending-actions-card__item ${
                index < actions.length - 1 ? "pending-actions-card__item--divider" : ""
              }`}
            >
              <div className="pending-actions-card__item-icon">
                <Iconography
                  icon={ACTION_ICONS[action.icon]}
                  size={IconographySizes.Small}
                />
              </div>
              <div className="pending-actions-card__item-text">
                <span className="pending-actions-card__item-title">{action.title}</span>
                {action.subtitle && (
                  <span className="pending-actions-card__item-subtitle">
                    {action.subtitle}
                  </span>
                )}
              </div>
              <div className="pending-actions-card__item-trail">
                <span
                  className={`pending-actions-card__status-dot pending-actions-card__status-dot--${action.statusDot}`}
                />
                <Iconography icon="chevronRight" size={IconographySizes.Small} />
              </div>
            </li>
          ))
        ) : (
          <li className="pending-actions-card__empty">No pending actions</li>
        )}
      </ul>

      <button type="button" className="pending-actions-card__more">
        More
        <Iconography icon="arrowUpRight" size={IconographySizes.Small} />
      </button>
    </div>
  );
};

export default PendingActionsCard;
